import { NgModule } from '@angular/core';
import { AuthImageDirective } from './auth-image.directive';

@NgModule({
  declarations: [AuthImageDirective],
  exports: [AuthImageDirective]
})
export class DirectivesModule { }
